import { App } from '@ps20-frontend/frontend-models';
import {
  AngebotsId,
  GlobalAction,
  WrappedSavedStates,
  WrappedSavedStatesLoaded
} from '@ps20-frontend/shop-integration-redux';

interface VwgStateForCleanup {
  angebotsId?: string;
  vorschaeden?: {
    elementarVorschaden?: {
      count?: number;
    };
  };
}

export function collectOldEleProducts(action: GlobalAction<WrappedSavedStatesLoaded>): AngebotsId[] {
  const actionPayload: WrappedSavedStates = action.payload.savedStatesLoaded;
  const loadedAppState = actionPayload.find(
    loadedState => loadedState.appId === App.SHOP_DASHBOARD
  );

  if (!loadedAppState) {
    return [];
  }

  const wasAlreadySavedWithUwEle = loadedAppState.state.savedWithUwEle === true;

  if (wasAlreadySavedWithUwEle) {
    return [];
  }

  const warenkorb = loadedAppState.state.warenkorb as {
    appId: App;
    angebotsId: string;
    beibehalten: boolean;
    versicherterRisikoort?: {
      zuerszone?: number;
    };
  }[];
  if (!warenkorb || warenkorb.length === 0) {
    return [];
  }

  const vwgStatesMap = new Map<string, VwgStateForCleanup>();
  actionPayload
    .filter(loadedState => loadedState.appId === App.VWG)
    .forEach(vwgState => {
      const angebotsId = vwgState.state.angebotsId;
      if (angebotsId) {
        vwgStatesMap.set(angebotsId, vwgState.state);
      }
    });

  return warenkorb.filter(angebot => {
    if (angebot.appId !== App.VWG || angebot.beibehalten === true) {
      return false;
    }

    const zuerszone = angebot.versicherterRisikoort?.zuerszone;

    if (zuerszone === 4) {
      return true;
    }

    if (zuerszone === 3) {
      const vwgState = vwgStatesMap.get(angebot.angebotsId);
      if (!vwgState) {
        return false;
      }

      const elementarvorschadenCount = vwgState.vorschaeden?.elementarVorschaden?.count;
      return elementarvorschadenCount > 0;
    }

    return false;
  });
}
